import { useEffect, useState } from 'react';

import styles from './Counter.module.scss';

interface FlapExpressionProps {
  expression: string;
  label?: string;
}

export const FlapExpression = ({ expression, label }: FlapExpressionProps) => {
  // init counter with static value to avoid ssr hydration error
  const [initialExpression, setInitialExpression] = useState<string | null>('-');

  useEffect(() => {
    setInitialExpression(null);
  }, []);

  return (
    <div className={styles.flapExpressionWrapper}>
      <div className={styles.flapExpression}>
        {expression.split('').map((expressionDigit, key) => (
          <div className={styles.flapExpressionItem} data-testid="flap-expression-item" key={key}>
            {initialExpression ?? expressionDigit}
          </div>
        ))}
      </div>
      {label ? (
        <div className={styles.flapExpressionLabel} data-testid="flap-expression-label">
          {label}
        </div>
      ) : null}
    </div>
  );
};
